import { NoBlending, ShaderMaterial, Uniform } from "three";

import fragmentShaderSource from "./glsl/LuminanceSaturation.frag";
import vertexShader from "./glsl/Common.vert";
import blendFunctions from "./glsl/BlendFunctions.frag";
import blendMode from "./glsl/BlendMode.frag";

/**
 * A simple copy shader material.
 */

export class LuminanceSaturationMaterial extends ShaderMaterial {

    constructor() {
        let fragmentShader = fragmentShaderSource.replace("BLEND_FUNCTIONS;", blendFunctions);
        fragmentShader = fragmentShader.replace("BLEND_MODE;", blendMode);

        super({
            name: "LuminanceSaturationMaterial",
            uniforms: {
                inputBuffer: new Uniform(null),
                opacity: new Uniform(1.0),
                blendID: new Uniform(0),

                satBlacks: new Uniform(0),
                satShadows: new Uniform(0),
                satMidtones: new Uniform(0),
                satHighlights: new Uniform(0),
                satWhites: new Uniform(0),
            },
            blending: NoBlending,
            depthWrite: false,
            depthTest: false,
            fragmentShader,
            vertexShader
        });
    }


    /**
     * The input buffer.
     *
     * @type {Texture}
     */

    set inputBuffer(value) {

        this.uniforms.inputBuffer.value = value;

    }

    /**
     * Sets the input buffer.
     *
     * @deprecated Use inputBuffer instead.
     * @param {Number} value - The buffer.
     */

    setInputBuffer(value) {

        this.uniforms.inputBuffer.value = value;

    }

    /**
     * Returns the opacity.
     *
     * @deprecated Use opacity instead.
     * @return {Number} The opacity.
     */

    getOpacity(value) {

        return this.uniforms.opacity.value;

    }

    /**
     * Sets the opacity.
     *
     * @deprecated Use opacity instead.
     * @param {Number} value - The opacity.
     */

    setOpacity(value) {

        this.uniforms.opacity.value = value;

    }

}
